import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toggleMegamenu, toggleSearchBar, toggleNotificationBar, setOffcanvas } from '../../actions/settingsAction';
import MyOpinionLogo from "../../assets/images/MyOpinion_Logo_Head.png";

const Header = ({ setOffcanvas, offcanvas }) => {

    const [scrolled, setScrolled] = useState(0)
    const scrollProgress = () => {
        const scrollPx = document.documentElement.scrollTop;
        const winHeightPx =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight;
        const scrolleda = `${scrollPx / winHeightPx * 100}%`;
        setScrolled(scrolleda)
    };
    window.addEventListener("scroll", scrollProgress);

    const progressBarStyle = {
        // height: "2px",
        // background: "#e91e63",
        width: scrolled
    };

    return (
        <>
            <nav className="navbar top-navbar">
                <div className="container-fluid">
                    <div className="navbar-left">
                        <div className="navbar-btn">
                            <Link to="/"><img src={MyOpinionLogo} alt="MyOpinion" className="img-fluid logo" /></Link>
                            <button type="button" className="btn-toggle-offcanvas" onClick={() => setOffcanvas(!offcanvas)}><i className="lnr lnr-menu fa fa-bars"></i></button>
                        </div>
                    </div>

                    <div className="navbar-right">
                        <div id="navbar-menu">
                            <ul className="nav navbar-nav">
                                <li><Link to="/login" className="icon-menu"><i className="icon-power"></i></Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="progress-container">
                    <div style={progressBarStyle} className="progress-bar" id="myBar"></div></div>
            </nav>
        </>
    );
}

const mapStateToProps = state => ({
    isMegaMenu: state.settings.isMegaMenu,
    offcanvas: state.settings.offcanvas,
})

const mapDispatchToProps = dispatch => ({
    toggleMegamenu: (e) => dispatch(toggleMegamenu(e)),
    toggleSearchBar: (e) => dispatch(toggleSearchBar(e)),
    toggleNotificationBar: (e) => dispatch(toggleNotificationBar(e)),
    setOffcanvas: (e) => dispatch(setOffcanvas(e)),
})
export default connect(mapStateToProps, mapDispatchToProps)(Header);